module.exports = __webpack_public_path__ + "b543a9ad792d1ad75925c1836e3db5dc.woff2";